// Inicijalizacija Firebase aplikacije
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import firebaseConfig from "./firebaseConfig";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Eksportuj auth i firestore da možeš koristiti u App.js
export const auth = getAuth(app);
export const db = getFirestore(app);
